<template>
  <div class="form-view__powered-by">
    Powered by
    <a
      href="https://baserow.io"
      target="_blank"
      title="Baserow - open source no-code database tool and Airtable alternative"
    >
      <Logo
        class="form-view__powered-by-logo"
        alt="Baserow - open source no-code database tool and Airtable alternative"
      />
    </a>
  </div>
</template>
